jQuery(document).ready(function ($) {
    const stickyForm = $('.stickyForm');

    if (!stickyForm.length) {
        return;
    }

    let stickyTopMinPos;
    let stickyBottomMaxPos;

    let stickyHeight;
    let windowHeight;
    let headerHeight;

    function setVariablesBasedOnScreenSize() {
        const stickyRow = stickyForm.closest('.fl-row-content-wrap');
        const header = $('header');
        const stickyRowHeight = stickyRow.height();

        windowHeight = $(window).height();

        stickyHeight = stickyForm.outerHeight(true);
        headerHeight = header.outerHeight(true);

        stickyTopMinPos = stickyRow.offset().top;

        stickyBottomMaxPos = stickyTopMinPos + stickyRowHeight - stickyHeight - headerHeight;
    }

    function handleScroll() {
        const windowTop = $(window).scrollTop();

        const validClassNames = [
            'default-stickiness',
            'stuck-to-bottom',
            'stuck-to-top'
        ];

        const classNamesToAdd = [];
        const preventSticky = stickyHeight && windowHeight < (stickyHeight + headerHeight);

        if (preventSticky) {
            classNamesToAdd.push('default-stickyness');
        }

        const shouldGetStuck = !preventSticky && stickyTopMinPos < windowTop;
        const stuckToBottom = stickyBottomMaxPos < windowTop;

        if (shouldGetStuck) {
            classNamesToAdd.push(stuckToBottom ? 'stuck-to-bottom' : 'stuck-to-top');
        }

        stickyForm.removeClass(validClassNames.filter(c => classNamesToAdd.indexOf(c) === -1).join(' '));
        stickyForm.addClass(classNamesToAdd.join(' '));
    }

    $(window).on('resize', () => requestAnimationFrame(setVariablesBasedOnScreenSize));
    $(window).on('scroll', () => requestAnimationFrame(handleScroll));

    const imagesLoaded = () => $('body').imagesLoaded(setVariablesBasedOnScreenSize);

    try {
        imagesLoaded();
    } catch (e) {
        console.log('imagesloaded not loaded, fall back to timeout');
        setTimeout(setVariablesBasedOnScreenSize, 3000);
    }

    $('iframe').on('load', () => {
        console.log('iframe load');
        setTimeout(setVariablesBasedOnScreenSize, 1000);
    });

    $(document).on('iframe-resize/ready', () => {
        console.log('iframe resize ready');
        setTimeout(setVariablesBasedOnScreenSize, 100);
    });
});